import { render, staticRenderFns } from "./FragmentDelfiShort.vue?vue&type=template&id=11242242&scoped=true"
import script from "./FragmentDelfiShort.vue?vue&type=script&lang=ts"
export * from "./FragmentDelfiShort.vue?vue&type=script&lang=ts"
import style0 from "./FragmentDelfiShort.vue?vue&type=style&index=0&id=11242242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11242242",
  null
  
)

export default component.exports